module.exports = __webpack_public_path__ + "static/media/scroll-to-top.dbd56c9c.svg";